import type React from 'react';

import { Modal } from 'ui';

import { ReviewComposer } from './ReviewComposer';
import classes from '../Chat.module.scss';

interface LeaveReviewModalProps {
  open: boolean;
  onClose: () => void;
  tutorUserId: number;
  chatId?: number | null;
  onSuccess?: () => void;
}

export const LeaveReviewModal: React.FC<LeaveReviewModalProps> = ({
  open,
  onClose,
  tutorUserId,
  chatId = null,
  onSuccess,
}) => {
  if (!Number.isFinite(tutorUserId) || tutorUserId <= 0) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose} widthModal="560px">
      <div className={classes['leave-review-modal']}>
        <ReviewComposer
          tutorUserId={tutorUserId}
          chatId={chatId}
          onDone={() => {
            onSuccess?.();
            onClose();
          }}
        />
      </div>
    </Modal>
  );
};
